// eslint-disable-next-line import/prefer-default-export
export const CREATE_CREATIVE_SOURCE_KEY = 'createCreativeSource';
